import {
  FETCH_CUSTOMER_FEEDBACK_LIST,
  RESET_CUSTOMER_FEEDBACK_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const customerFeedbackListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CUSTOMER_FEEDBACK_LIST:
      return { list: action.payload, others: action.others };
    case RESET_CUSTOMER_FEEDBACK_LIST:
      return initialState;
    default:
      return state;
  }
};

export default customerFeedbackListReducer;
